import axios from "axios";

const API_BASE = process.env.REACT_APP_API_BASE;

export async function fetchRegisterAccess() {
  const response = await axios.get(`${API_BASE}/register-access`);
  return Boolean(response.data?.allowed);
}
